export default __webpack_public_path__ + "static/media/22.1bf7aff1.jpg";